const $inject = [
  '$state',
  '$scope',
  'NotificationService',
  '$timeout'
];

export default class DigitalSigningSuccessController {
  constructor(
    $state,
    $scope,
    NotificationService,
    $timeout
  ) {

    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.NotificationService = NotificationService;

    this.NotificationService.message('Sie haben das Dokument erfolgreich digital signiert.');

    this.$timeout(() => {
      this.$state.go('inApp.meineakte.missing_documents');
    }, 3000);
  }
}

DigitalSigningSuccessController.$inject = $inject;
